// extracted by mini-css-extract-plugin
export default {"body":"NoMatch_body__p3o3L"};